import { render, staticRenderFns } from "./customInput.vue?vue&type=template&id=1260e8de&scoped=true&"
import script from "./customInput.vue?vue&type=script&lang=js&"
export * from "./customInput.vue?vue&type=script&lang=js&"
import style0 from "./customInput.vue?vue&type=style&index=0&id=1260e8de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1260e8de",
  null
  
)

export default component.exports